import request from '@/utils/request';

export function usersList(data) {
  return request({
    url: '/adminapi/user/users',
    method: 'get',
    params: data
  });
}
export function addUser(data) {
  return request({
    url: '/adminapi/user/admin/add',
    method: 'post',
    data
  });
}

export function addTenantUser(data) {
  return request({
    url: '/adminapi/user/add',
    method: 'post',
    data
  });
}
export function userChangePwd(data) {
  return request({
    url: '/adminapi/user/changepwd',
    method: 'post',
    data
  });
}
export function deptEnable(data) {
  return request({
    url: '/adminapi/user/enable',
    method: 'post',
    data
  });
}
export function deptDisable(data) {
  return request({
    url: '/adminapi/user/disable',
    method: 'post',
    data
  });
}

export function userChangePwdConfirm(data) {
  return request({
    url: '/adminapi/admin_user/change',
    method: 'put',
    data
  });
}
export function blacklist(data) {
  return request({
    url: '/adminapi/representative/blacklist',
    method: 'get',
    params: data
  });
}
export function blackAdd(data) {
  return request({
    url: '/adminapi/representative/blacklist/add',
    method: 'post',
    data
  });
}

export function delBlackAccount(data) {
  return request({
    url: '/adminapi/representative/blacklist',
    method: 'delete',
    data
  });
}
